import { gql } from "@apollo/client";


export const FINISH_TASK_APPOINTMENT = gql`
  mutation FinishTaskAppointment($input: FinishTaskAppointmentInput!) {
    finishTaskAppointment(input: $input)
  }
`;

// 输入类型定义
export interface FinishTaskAppointmentInput {
  taskId: string;
  appointmentId: string;
}